import http from "@/http-common";
import './security';

class UserService {
  login (data) {
      return http.post("/auth/login", data);
  }

  getAll() {
    return http.get("/user/data");
  }

  getSelf(id) {
    return http.get(`/user/self/data/${id}`);
  }

  get(id) {
    return http.get(`/user/data/${id}`);
  }

  create(data) {
    return http.post("/user/corporate/register", data);
  }

  updateSelf(data) {
    var resData = {};
    resData.user = data;

    return http.post(`/user/self/data/${resData.user._id}`, resData);
  }

  update(data) {
    var resData = {};
    resData.user = data;

    return http.post(`/user/data/${resData.user._id}`, resData);
  }

  delete(id) {
    return http.delete(`/user/data/${id}`);
  }

  getAllRoles() {
    return http.get("/user/roles");
  }

  updateRole(data) {
    return http.put(`/user/roles/${data._id}`, data)
  }

  deleteRole(id) {
    return http.delete(`/user/roles/${id}`)
  }

  createRole(data) {
    return http.post("/user/roles", data);
  }

  getAllActions() {
    return http.get("/user/actions");
  }

  getSections() {
    return http.get("/user/sections");
  }

  isUserAdmin() {
    let isAdmin = false;

    let currentUser = JSON.parse(localStorage.getItem('user'));

    if(currentUser && currentUser.role && currentUser.role.alias == 'Administrador'){            
        isAdmin = true;
    }
    
    return isAdmin;
  }

}

export default new UserService();
